import { render } from "./EventCard.vue?vue&type=template&id=dbf25d14&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=dbf25d14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dbf25d14"

export default script